// @flow
import * as React from "react"
import { compose, type HOC } from "recompose"
import withOpen from "hoc/withOpen"
import withConnect from "hoc/withConnect"
import LogoLink from "components/LogoLink"
import { selectAppConfig } from "data/app/selectors"
import { clear } from "data/search/actions"
import SearchAutocomplete from "../SearchAutocomplete"
import AvatarMenu from "./AvatarMenu"
import { LogoWrap, RightWrap } from "./styled"
import ShoppingBasketLink from "./ShoppingBasketLink"
import ReservationsLink from "./ReservationsLink"

const DesktopLoggedInNav = ({ appConfig, isOpen, open, close, clear }) => (
  <React.Fragment>
    <LogoWrap>
      <LogoLink type="default" />
    </LogoWrap>
    <SearchAutocomplete
      initialValue=""
      isOpen={isOpen}
      open={open}
      close={close}
    />
    <RightWrap>
      {appConfig && appConfig.enableBasket && <ShoppingBasketLink />}
      <ReservationsLink />
      <AvatarMenu />
    </RightWrap>
  </React.Fragment>
)

const mapStateToProps = state => ({
  appConfig: selectAppConfig(state),
})

const mapDispatchToProps = {
  clear,
}

const enhancer: HOC<*, {||}> = compose(
  withOpen,
  withConnect(mapStateToProps, mapDispatchToProps),
)

export default enhancer(DesktopLoggedInNav)



// WEBPACK FOOTER //
// ./src/pages/_Page/MainNav/LoggedInNav/DesktopLoggedInNav/index.js